import { GroupChannelListProvider } from '@sendbird/uikit-react/GroupChannelList/context';
import React from 'react';
import { useSelector } from 'react-redux';

import { selectChannelUrl } from '_store/chat/selector';

import CustomGroupChannelListView from './CustomGroupChannelListView';

const CustomGroupChannelList = () => {
  const channelUrl = useSelector(selectChannelUrl);

  return (
    <GroupChannelListProvider selectedChannelUrl={channelUrl}>
      <CustomGroupChannelListView />
    </GroupChannelListProvider>
  );
};

export default CustomGroupChannelList;
